import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { AuthForm } from "@/components/auth/AuthForm";
import { useLanguage } from "@/contexts/LanguageContext";

interface LoginModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const LoginModal = ({ open, onOpenChange }: LoginModalProps) => {
  const { isRTL } = useLanguage();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md p-0 border-0 bg-transparent shadow-none data-[state=open]:slide-in-from-bottom-8">
        <DialogTitle className="sr-only">Sign in</DialogTitle>
        <DialogDescription className="sr-only">Sign in to JouRex Trading Center</DialogDescription>
        <div className="rounded-2xl overflow-hidden bg-card shadow-elevated">
          {/* Reuse existing AuthForm — it already contains all logic */}
          <div className="[&>div]:!p-0 [&>div]:!min-h-0 [&_.absolute.inset-0]:!hidden">
            <AuthForm isRTL={isRTL} forcedRole="trader" />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
